import type { FC } from 'react';
import { useEffect, useState } from 'react';

import { Images } from '../../images';
import type { CombineViewProps } from '../../types';
import { ViewType } from '../../types';
import { Button } from '../../uikit/web/button';
import { clearTmpAccount } from '../../utils';
import { PasswordLogin } from './password-login';
import { VerifyCodeLogin } from './verify-code-login';
import { loginInjector } from '../../utils/init';
import { cx } from '@flowus/common/cx';

export enum DisplayType {
  INPUT_PASSWORD = 1, //密码登录
  INPUT_VERIFY_CODE = 2, //验证码登录
}

export const Login: FC<CombineViewProps & { displayType?: DisplayType }> = (props) => {
  const [displayType, setDisplayType] = useState(DisplayType.INPUT_PASSWORD);
  const showPassword = displayType === DisplayType.INPUT_PASSWORD;

  useEffect(() => {
    if (props.displayType) {
      setDisplayType(props.displayType);
    }
  }, [props.displayType]);

  return (
    <div className="flex w-full flex-col">
      {showPassword && !props.quickRegister ? (
        <PasswordLogin {...props} />
      ) : (
        <VerifyCodeLogin {...props} />
      )}
      {!props.quickRegister && (
        <div className="sm:px-5">
          <div className="mt-7 h-px w-full" />
          <Button
            onClick={() => {
              //需要重置accountStatus，下次密码登录才会继续校验是否已注册
              props.switchViewType({
                type: ViewType.LOGIN,
                props: {
                  accountStatus: undefined,
                  displayType: showPassword
                    ? DisplayType.INPUT_VERIFY_CODE
                    : DisplayType.INPUT_PASSWORD,
                },
              });
            }}
            colorType="white"
            className={cx('t-btn-switch-login text-t1 h-[50px] w-full', {
              hidden: showPassword && loginInjector.noEmailService && loginInjector.noSMSService,
            })}
            size="auto"
          >
            {showPassword ? '使用验证码登录' : '使用密码登录'}
          </Button>
          <div
            className="text-t1 mt-3 flex cursor-pointer justify-center"
            onClick={() => {
              clearTmpAccount();
              props.switchViewType({
                type: ViewType.REGISTER,
                props: {
                  accountStatus: undefined,
                },
              });
            }}
          >
            注册账号
          </div>
          {!props.hideThirdPartLogin && (
            <>
              <div className="flex items-center mt-8">
                <div className="h-px w-full bg-grey6" />
                <span className="text-grey4 flex-shrink-0 mx-5">其他登录方式</span>
                <div className="h-px w-full bg-grey6" />
              </div>
              <div className="flex justify-center mt-4">
                <img
                  src={Images.wechatBtn}
                  className="mx-3.5 cursor-pointer hover:opacity-80"
                  onClick={() => {
                    clearTmpAccount();
                    props.switchViewType({
                      type: ViewType.WECHAT_LOGIN,
                    });
                  }}
                />
                {/* <img
                  src={Images.qqLogo}
                  className="mx-3.5 cursor-pointer hover:opacity-80"
                  onClick={() => {
                    // props.switchViewType({
                    //   type: ViewType.QQ_LOGIN,
                    // });
                  }}
                /> */}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};
export default Login;
